import React from 'react';
import GithubCorner from 'react-github-corner';

const GithubBanner = () => (
  <div className="github-banner">
    <GithubCorner
      href="https://github.com/pamcy/React-ToDoList-App"
      bannerColor="#283044"
      size="77"
      target="_blank"
    />
  </div>
);

export default GithubBanner;
